export function compare(dom: string | HTMLElement): void {
	let nodes: NodeListOf<Element> | undefined
	if (typeof dom === 'string') {
		const element = document.getElementById(dom)
		if (!element) return
		nodes = element.querySelectorAll('.to-compare')
	} else if (dom instanceof HTMLElement) {
		nodes = dom.querySelectorAll('.to-compare')
	} else {
		return
	}

	if (!nodes || nodes.length === 0) return

	// 使用 Vue 3 兼容的方式访问组件实例
	for (let i = 0; i < nodes.length; i++) {
		const node = nodes[i] as Element

		// 尝试通过 Vue 3 的方式获取组件实例
		if ('__vueParentComponent' in node) {
			const componentInstance = (node as any).__vueParentComponent
			if (componentInstance && typeof componentInstance.exposed?.compare === 'function') {
				componentInstance.exposed.compare()
			}
		}
		// 如果是 Vue 组件挂载的根元素，可以通过 ref 访问
		else if (node instanceof HTMLElement) {
			// 查找组件实例（如果通过 ref 挂载）
			const vueInstance = (node as any)._vnode?.ctx
			if (vueInstance && typeof vueInstance.exposed?.compare === 'function') {
				vueInstance.exposed.compare()
			}
		}
	}
}

// 兼容默认导出
export default compare
